import React from 'react';
import PropTypes from 'prop-types';
import truncate from 'lodash/truncate';

const File = ({ file }) => (
  <div className="row p-3 border-top" key={file.url}>
    <div className="col-12">
      <a
        className="d-flex flex-row no-decoration"
        href={file.url}
        target="_blank"
      >
        <i className="icon icon-file text-gray-light t-38" />
        <span className="text-gray t-14 align-self-center">
          {truncate(file.name, { length: 30 })}
        </span>
      </a>
    </div>
  </div>
);

File.propTypes = {
  file: PropTypes.object,
};

export default File;



// WEBPACK FOOTER //
// ./src/components/ProjectView/File/File.js